// Meteor.settings.public, also where it is missing: client-bundled code (collections.js, the rules files) runs in the
// browser too - in the methods' simulation - where the Quasar client has no Meteor settings (#221)
import { Meteor } from 'meteor/meteor';
export var publicSettings = function publicSettings() {
  return Meteor.settings && Meteor.settings.public || {};
}; // the Brevo API key: in the server-only part of the settings (settings.prod.json `brevo.apiKey`), never in the code - this
// file is bundled into the browser, the settings outside `public` are not (#224). Only production has one (#143)

export var brevoApiKey = function brevoApiKey() {
  return Meteor.settings && Meteor.settings.brevo && Meteor.settings.brevo.apiKey || null;
}; // the mail server as an SMTP URL, user and password in it: in the server-only part of the settings too
// (settings.prod.json `mail.url`, #9); only production sends mail (sendHtmlEmail)

export var mailUrl = function mailUrl() {
  return Meteor.settings && Meteor.settings.mail && Meteor.settings.mail.url || null;
};